import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { AssetsProvider } from "@/context/AssetsContext";
import { SiteConfigProvider } from "@/context/SiteConfigContext";
import SmoothScroll from "@/components/SmoothScroll";
import Landing from "@/pages/Landing";
import Providers from "@/pages/Providers";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function App() {
  return (
    <AuthProvider>
      <AssetsProvider>
        <SiteConfigProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<SmoothScroll><Landing /></SmoothScroll>} />
              <Route path="/providers" element={<Providers />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminDashboard />} />
            </Routes>
          </BrowserRouter>
        </SiteConfigProvider>
      </AssetsProvider>
    </AuthProvider>
  );
}

export default App;
